
<template>
  <TabsContainer
    v-if="tabTemplates && tabTemplates.length > 1"
    ref="tabsContainer"
    :key="tabTemplates.length"
    :tabNames="renderTabNames"
    :getCurrentTab="_getCurrentTab"
    v-on="$listeners"
  >
    <template
      v-for="(tab, index) in tabTemplates"
      #[`icon-${index}`]
    >
      <slot
        :name="`icon-${index}`"
      />
    </template>
    <template v-for="(tab, index) in tabTemplates">
      <div
        :key="tab.tabName"
        :slot="`tab-${index}`"
      >
        <keep-alive>
          <component
            :is="(index === currentTabIndex || index === privateCurTabIndex) ? tab.component : ComponentNoop"
            v-if="showCondition(tab.showCondition)"
            :ref="tab.ref || ''"
            v-bind="{ ...tab.params }"
          />
        </keep-alive>
      </div>
    </template>
  </TabsContainer>
  <component
    :is="tabTemplates[0].component"
    v-else-if="tabTemplates && tabTemplates.length === 1"
  />
</template>

<script>
import TabsContainer from '@/controls/TabsContainer.vue'
const ComponentNoop = () => {}

export default ({
  name: 'DynamicTabsContainer',
  components: {
    TabsContainer,
  },
  props: {
    getCurrentTab: {
      type: Function,
      default: () => {},
    },
    currentTabIndex: {
      type: Number,
      default: 0,
    },
    tabTemplates: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      ComponentNoop,
      privateCurTabIndex: 0,
    }
  },
  computed: {
    renderTabNames () {
      return this.tabTemplates.map(item => item.i18nPathKey ? this.$t(item.i18nPathKey) : item.tabName)
    },
  },
  methods: {
    _getCurrentTab (index) {
      if (typeof this.getCurrentTab === 'function') this.getCurrentTab(index)
      this.privateCurTabIndex = index
      this.$emit('tabIndex', index)
    },
    tabIndex () {
      return this.currentTabIndex || this.privateCurTabIndex
    },
    showCondition (condition) {
      return condition === undefined ? true : condition
    },
  },
})
</script>
